// import React, { useState, useEffect, use } from 'react'
// import {
//     BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
//     Scatter, ComposedChart, Line,
// } from 'recharts';

// import { getMonthWiseTicketSizeByDateAPI, SaveLockTicketSizeMonthData, UnlockTicketSizeMonthData } from './ActionCreator';
// import moment from 'moment';
// import Loader from '../../../presentationals/Loader/Loader.component'
// import MenuBar from './MenuBar'
// import Popup from '../../../presentationals/Popup/Popup.component'
// const differenceDate = () => {
//     let d = new Date()
//     let todaysDate = d.getDate();
//     return todaysDate - 1
// }

// const InitalDate = (type) => {
//     const FirstDay = moment().subtract(differenceDate(), 'days');
//     if (type === 'fromDate') {
//         const fromdate = FirstDay.format('YYYY-MM-DD');
//         return fromdate
//     } else if (type === 'toDate') {
//         const todate = moment(new Date).format('YYYY-MM-DD')
//         return todate
//     }
// }


// const CACDashboard = ({ nbfcList, admin, handleActiveFilteration, currentActiveFilters }) => {
//     const [view, setView] = useState("list")
//     const [loader, setLoader] = useState(false)
//     const [GraphBoxHeight, setGraphBoxHeight] = useState("")
//     const [selectedDataIndex, setselectedDataIndex] = useState("-1")
//     const [selectedDataHeading, setselectedDataHeading] = useState("")
//     const [selectedData, setselectedData] = useState([])
//     const [ActiveMonthFilter, setActiveMonthFilter] = useState(currentActiveFilters?.ActiveMonthFilter ?? "")
//     const [editData, setEditData] = useState({ show: false, data: {} })
//     const [editedValues, setEditedValues] = useState({});
//     const [ListType, setListType] = useState("list")
//     const [APIData, setAPIData] = useState()
//     const [popup, setpopup] = useState({ show: false, popupStatus: "" })
//     const [payload, setPayload] = useState({
//         fromDate: currentActiveFilters?.fromDate ?? "",
//         toDate: currentActiveFilters?.toDate ?? "",
//         nbfcId: currentActiveFilters?.nbfcId ?? "",
//         productId: currentActiveFilters?.productId ?? ""
//     })


//     useEffect(() => {
//         getMonthWiseCollectionEfficiencyByDateFn(payload)
//     }, [])

//     useEffect(() => {
//         const data = {
//             fromDate: payload?.fromDate ?? "", toDate: payload?.toDate ?? "", nbfcId: payload?.nbfcId ?? "",
//             productId: payload?.productId ?? "",
//             ActiveMonthFilter: ActiveMonthFilter ?? ""
//         }
//         handleActiveFilteration(data)
//     }, [payload, ActiveMonthFilter])

//     const handleDate = (e, type) => {
//         if (type === "applyFilter") {
//             setActiveMonthFilter("")
//             setselectedDataIndex("-1")
//             setselectedDataHeading("")
//             setselectedData([])
//             getMonthWiseCollectionEfficiencyByDateFn(payload)
//         } else {
//             setPayload((prev) => ({
//                 ...prev,
//                 [type]: e.target.value
//             }))
//         }
//     }

//     const handlemonthFilter = (type) => {
//         setActiveMonthFilter(type)
//         const { fromDate, toDate } = getDateRange(type);
//         const obj = {
//             fromDate: fromDate,
//             toDate: toDate,
//             nbfcId: payload?.nbfcId || "",
//             productId: payload?.productId || ""
//         }
//         setPayload(obj)
//         setselectedDataIndex("-1")
//         setselectedDataHeading("")
//         setselectedData([])
//         getMonthWiseCollectionEfficiencyByDateFn(obj)
//     }



//     const getMonthWiseCollectionEfficiencyByDateFn = (data) => {
//         const sDate = moment(data?.fromDate).format("DD-MM-YYYY")
//         const eDate = moment(data?.toDate).format("DD-MM-YYYY")
//         setLoader(true)
//         getMonthWiseTicketSizeByDateAPI(sDate, eDate, data?.nbfcId, data?.productId, callback => {
//             setLoader(false)
//             if (callback && callback?.message == "success" && callback?.status == 200) {
//                 setAPIData(callback?.data)
//                 setTimeout(() => {
//                     HandlechartHeight()
//                 }, 200)
//             } else {
//                 setAPIData([])
//             }
//         })
//     }

//     const handleSelectedRow = (fieldKey, index) => {
//         if (ListType == "edit") {
//             setselectedDataIndex("-1")
//             setselectedDataHeading("")
//             setselectedData([])
//         } else {
//             if (selectedDataIndex == index) {
//                 setselectedDataIndex("-1")
//                 setselectedDataHeading("")
//                 setselectedData([])
//             } else {
//                 setselectedDataHeading(fieldKey)
//                 setselectedDataIndex(index)
//                 const formattedData = APIData?.map(item => ({
//                     date: item?.monthName,
//                     value: item?.[fieldKey]
//                 }));

//                 setselectedData(formattedData);
//             }
//         }
//     }

//     const HandlechartHeight = () => {
//         let ele = document.getElementById("tableHeight")?.clientHeight;
//         setGraphBoxHeight(ele)
//     }

//     const handleEdit = (value, data) => {
//         setEditData({ show: value, data: data })
//         if (value == true) {
//             setListType("edit")
//             setEditedValues(data)
//             setselectedDataIndex("-1")
//             setselectedDataHeading("")
//             setselectedData([])
//         } else {
//             setListType("list")
//             getMonthWiseCollectionEfficiencyByDateFn(payload)
//         }
//     }

//     const handleSavingApi = (type, data) => {
//         console.log("editedValues", editedValues, "da", data)
//         if (type == "lock") {
//             const obj = {
//                 "projectedLoanAmtDisbrused": data?.Projected_Loan_Amount_Disbursed,
//                 "actualLoanAmtDisbrused": data?.Actual_Amount_Disbursed,
//                 "actualLoanAmtDisbrusedNC": data?.Actual_Amount_Disbursed_NC,
//                 "actualLoanAmtDisbrusedEC": data?.Actual_Amount_Disbursed_EC,
//                 "averageProjectedLoanTicketSize": data?.Average_Projected_Loan_Ticket_Size,
//                 "averageNewLoanTicketSizeDisbrused": data?.Average_New_Loan_Ticket_Size_Disbursed,
//                 "averageExistingLoanTicketSizeDisbrushed": data?.Average_Existing_Loan_Ticket_Size_Disbursed,
//                 "averageLoanTicketSizeDisbrused": data?.Average_Loan_Ticket_Size_Disbursed,
//                 "month": data?.Month_Name,
//                 "createdBy": admin.emailId,
//                 "lock": true
//             }
//             SaveLockTicketSizeMonthData(obj, callback => {
//                 console.log("locked")
//                 if (callback && callback?.message == "success" && callback?.status == 200) {
//                     setpopup({ show: true, popupStatus: 'Data Locked Successfully' })
//                     getMonthWiseCollectionEfficiencyByDateFn(payload)
//                 } else {
//                     setpopup({ show: true, popupStatus: 'error Locking' })
//                 }
//                 removePopup()
//             })
//         } else if (type == "save") {
//             const obj = {
//                 "projectedLoanAmtDisbrused": editedValues?.Projected_Loan_Amount_Disbursed,
//                 "actualLoanAmtDisbrused": editedValues?.Actual_Amount_Disbursed,
//                 "actualLoanAmtDisbrusedNC": editedValues?.Actual_Amount_Disbursed_NC,
//                 "actualLoanAmtDisbrusedEC": editedValues?.Actual_Amount_Disbursed_EC,
//                 "averageProjectedLoanTicketSize": editedValues?.Average_Projected_Loan_Ticket_Size,
//                 "averageNewLoanTicketSizeDisbrused": editedValues?.Average_New_Loan_Ticket_Size_Disbursed,
//                 "averageExistingLoanTicketSizeDisbrushed": editedValues?.Average_Existing_Loan_Ticket_Size_Disbursed,
//                 "averageLoanTicketSizeDisbrused": editedValues?.Average_Loan_Ticket_Size_Disbursed,
//                 "month": editedValues?.Month_Name,
//                 "createdBy": admin.emailId,
//                 "lock": false
//             }
//             SaveLockTicketSizeMonthData(obj, callback => {
//                 if (callback && callback?.message == "success" && callback?.status == 200) {
//                     getMonthWiseCollectionEfficiencyByDateFn(payload)
//                     setpopup({ show: true, popupStatus: 'Data Saved Successfully' })
//                     handleEdit(false, "")
//                 } else {
//                     setpopup({ show: true, popupStatus: 'Error saving data' })
//                 }
//                 removePopup()
//             })
//         }
//     }

//     const closePopup = () => {
//         setpopup({ show: false, popupStatus: '' })
//     }

//     const removePopup = () => {
//         setTimeout(() => {
//             closePopup()
//         }, 5000)
//     }


//     const handleUnlock = (data) => {
//         console.log("daa", data)
//         const obj = { "month": data?.Month_Name ?? "", "createdBy": admin?.emailId, "lock": true }
//         UnlockTicketSizeMonthData(obj, callback => {
//             console.log("locked")
//             if (callback && callback?.message == "success" && callback?.status == 200) {
//                 setpopup({ show: true, popupStatus: 'Data UnLocked Successfully' })
//                 getMonthWiseCollectionEfficiencyByDateFn(payload)
//             } else {
//                 setpopup({ show: true, popupStatus: 'error UnLocked' })
//             }
//             removePopup()
//         })
//     }

//     return (
//         <>
//             {
//                 loader ? <Loader /> : ''
//             }
//             {
//                 popup?.show ?
//                     <Popup popupStatus={popup?.popupStatus} closePopup={closePopup} />
//                     : ''}

//             <div className="Filterations">
//                 <div className="row">
//                     <div className="col-lg-2 col-sm-3 col-xs-12">
//                         <div className="inputgrp">
//                             <label htmlFor="fromDate" className='inputlabel' style={{ fontSize: '12px' }}>From</label>
//                             <input type="date" id='fromDate' className='inputtag' value={payload?.fromDate} onChange={(e) => handleDate(e, 'fromDate')} disabled={view == "edit" ? true : false} />
//                         </div>
//                     </div>
//                     <div className="col-lg-2 col-sm-3 col-xs-12">
//                         <div className="inputgrp">
//                             <label htmlFor="toDate" className='inputlabel' style={{ fontSize: '12px' }}>To</label>
//                             <input type="date" id='toDate' className='inputtag' value={payload?.toDate} min={payload?.fromDate} onChange={(e) => handleDate(e, 'toDate')} disabled={view == "edit" ? true : false} />
//                         </div>
//                     </div>
//                     <div className="col-lg-2 col-sm-3 col-xs-12">
//                         <div className="inputgrp">
//                             <label htmlFor="" className='inputlabel' style={{ fontSize: '12px' }}>NBFC</label>
//                             <select className='form-control' disabled={view == "edit" ? true : false} style={{ padding: '9px' }} onChange={(e) => handleDate(e, 'nbfcId')} value={payload?.nbfcId}>
//                                 <option value="">Select NBFC</option>
//                                 {
//                                     nbfcList && nbfcList?.length > 0 ?
//                                         nbfcList?.map((value, index) => {
//                                             return (
//                                                 <option value={value?.nbfcId}>{value?.name}</option>
//                                             )
//                                         })
//                                         : ''}
//                             </select>
//                         </div>
//                     </div>
//                     <div className="col-lg-2 col-sm-3 col-xs-12">
//                         <div className="inputgrp">
//                             <label htmlFor="" className='inputlabel' style={{ fontSize: '12px' }}>Product</label>
//                             <select className='form-control' disabled={view == "edit" ? true : false} style={{ padding: '9px' }} onChange={(e) => handleDate(e, 'productId')} value={payload?.productId}>
//                                 <option value="">Select Product</option>
//                                 <option value="loan">Loan</option>
//                             </select>
//                         </div>
//                     </div>
//                     <div className="col-lg-2 col-md-2 col-sm-3 col-xs-12" style={{ marginTop: '20px' }}>
//                         <div style={{ display: 'flex' }}>
//                             <button className='btn btn-primary' style={{ marginTop: '10px', padding: '10px 11px' }} onClick={(e) => handleDate(e, 'applyFilter')} disabled={view == "edit" ? true : false}>Apply Filter</button>
//                         </div>
//                     </div>

//                 </div>
//                 <div className="row" style={{ marginTop: '6px' }}>
//                     <div className="col-lg-4 col-md-6 col-sm-8 col-xs-12" style={{ marginTop: '20px' }}>
//                         <div className="inputgrp">
//                             <label className='inputlabel' style={{ fontSize: '13px' }}>Month Wise</label>
//                             <div style={{ display: 'flex', alignItems: 'center' }}>
//                                 <button className={`filterbtn2 ${ActiveMonthFilter === '3month' ? 'active' : ''}`} onClick={() => handlemonthFilter('3month')} disabled={view == "edit" ? true : false} >last 3 Month</button>
//                                 <button className={`filterbtn2 ${ActiveMonthFilter === '6month' ? 'active' : ''}`} onClick={() => handlemonthFilter('6month')} disabled={view == "edit" ? true : false} >last 6 Month</button>
//                                 <button className={`filterbtn2 ${ActiveMonthFilter === '1year' ? 'active' : ''}`} onClick={() => handlemonthFilter('1year')} disabled={view == "edit" ? true : false} >last 1 Year</button>
//                             </div>
//                         </div>
//                     </div>

//                 </div>
//             </div>
//             <hr />

//             <div className="Dashboardsmis">

//                 <div className="row" style={{ position: 'relative' }}>

//                     <div className={`${selectedDataIndex == '-1' ? 'col-xs-12' : "col-md-6 col-xs-12"} transition-col`} style={{ boxShadow: selectedDataIndex !== '-1' ? '0 0 20px 2px #ddd' : "none" }} id="tableHeight">
//                         <div className="table" style={{ marginTop: '20px' }}>
//                             <div className="phocket-table-new newTable" style={{ overflowX: 'auto', marginTop: '0px' }}>
//                                 <table>
//                                     <thead style={{ position: 'sticky', top: 0 }}>
//                                         <tr>
//                                             <th style={{ position: 'sticky', left: 0, zIndex: '1' }}>Particulars</th>
//                                             {
//                                                 APIData?.length > 0 && APIData?.map((item, index) => (

//                                                     <th key={index}>

//                                                         <MenuBar
//                                                             totalData={item}
//                                                             ButtonName={item?.Month_Name}
//                                                             ListType={ListType}
//                                                             EditData={editedValues}
//                                                             onEdit={() => {
//                                                                 handleEdit(true, item)
//                                                             }}
//                                                             onView={() => {
//                                                                 handleEdit(false, "")
//                                                             }}
//                                                             onSave={() => {
//                                                                 handleSavingApi("save", item)
//                                                             }}
//                                                             onLock={() => {
//                                                                 handleSavingApi("lock", item)
//                                                             }}
//                                                             onUnLock={() => {
//                                                                 handleUnlock(item)
//                                                             }}
//                                                         />
//                                                     </th>
//                                                 ))
//                                             }
//                                         </tr>
//                                     </thead>
//                                     <tbody>
//                                         {
//                                             APIData?.length > 0 &&
//                                             Object.keys(APIData[0])?.filter(key => key !== 'Month_Name').map((fieldKey, index) => {
//                                                 if (fieldKey == "Month_Name" || fieldKey == "isLocked" || fieldKey == "canEdit") {
//                                                     return
//                                                 }
//                                                 return (
//                                                     <tr key={index} style={{ cursor: 'pointer', background: selectedDataIndex == index ? "#7fb0ae" : "" }} onClick={() => handleSelectedRow(fieldKey, index)}>
//                                                         <td className='leftsticky'><b>{fieldKey?.replace(/_/g, " ")}</b></td>
//                                                         {
//                                                             APIData?.map((item, colIndex) => {
//                                                                 const isEditing = editData.show && editData.data.Month_Name === item.Month_Name;
//                                                                 const monthKey = item.Month_Name;
//                                                                 const inputKey = `${fieldKey}_${monthKey}`;
//                                                                 return (
//                                                                     <>
//                                                                         {
//                                                                             isEditing && (fieldKey == "Average_Projected_Loan_Ticket_Size" || fieldKey == "Projected_Loan_Amount_Disbursed") ?
//                                                                                 <td>
//                                                                                     <input style={{ border: '1px solid #ccc', borderRadius: '6px', padding: '10px' }} type="number" value={editedValues[fieldKey] ?? item[fieldKey]}
//                                                                                         onChange={(e) => {
//                                                                                             setEditedValues(prev => ({
//                                                                                                 ...prev,
//                                                                                                 [fieldKey]: e.target.value
//                                                                                             }));
//                                                                                         }}
//                                                                                     />
//                                                                                 </td>
//                                                                                 :
//                                                                                 <td style={{ color: selectedDataIndex == index ? "#fff" : "#000" }} key={colIndex}>{(Number(item[fieldKey]))?.toLocaleString("en-US")}</td>
//                                                                         }
//                                                                     </>
//                                                                 )
//                                                             })
//                                                         }
//                                                     </tr>
//                                                 )
//                                             })
//                                         }
//                                     </tbody>
//                                 </table>
//                             </div>
//                         </div>
//                     </div>
//                     {
//                         selectedData?.length > 0 ?
//                             <div className="col-md-6 col-xs-12">
//                                 <div className="charts" style={{ height: GraphBoxHeight, border: 'none', boxShadow: selectedDataIndex !== '-1' ? '0 0 20px 2px #ddd' : "none" }}>
//                                     <h3 style={{ fontSize: '16px' }}>{selectedDataHeading?.replace(/_/g, " ")}</h3>
//                                     <div className="chartbar" style={{ height: GraphBoxHeight - 50 }}>

//                                         <ResponsiveContainer width="100%" height="100%">
//                                             <BarChart width={150} height={40} data={selectedData}
//                                                 barSize={ActiveMonthFilter === '3month' ? 40 : ActiveMonthFilter === '6month' ? 30 : 20}
//                                                 margin={{
//                                                     top: 20,
//                                                     right: 0,
//                                                     left: 30,
//                                                     bottom: 5,
//                                                 }}
//                                             >
//                                                 <defs>
//                                                     <linearGradient id="barGradient" x1="0" y1="0" x2="0" y2="1">
//                                                         <stop offset="0%" stopColor="#8884d8" stopOpacity={1} />
//                                                         <stop offset="100%" stopColor="#fff" stopOpacity={1} />
//                                                     </linearGradient>
//                                                 </defs>
//                                                 <CartesianGrid stroke='none' />
//                                                 <XAxis dataKey="date" />
//                                                 <YAxis padding={{ top: 20 }} />
//                                                 <Tooltip />
//                                                 <Bar dataKey="value" fill="url(#barGradient)" radius={[10, 10, 10, 10]} />
//                                             </BarChart>
//                                         </ResponsiveContainer>
//                                     </div>
//                                 </div>
//                             </div>
//                             : ''}
//                 </div>

//             </div>
//         </>
//     )
// }

// export default CACDashboard


// const getDateRange = (type) => {
//     const today = moment();
//     let fromDate;

//     if (type === "3month") {
//         fromDate = moment().subtract(3, 'months').startOf('month');
//     } else if (type === "6month") {
//         fromDate = moment().subtract(6, 'months').startOf('month');
//     } else if (type === "1year") {
//         fromDate = moment().subtract(1, 'year').startOf('month');
//     } else {
//         return null;
//     }

//     const toDate = moment().subtract(1, 'months').endOf('month');

//     return {
//         fromDate: fromDate.format('YYYY-MM-DD'),
//         toDate: toDate.format('YYYY-MM-DD'),
//     };
// };

import React, { useState, useEffect } from 'react'
import {
    BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
} from 'recharts';
import { getMonthWiseTicketSizeByDateAPI, SaveLockTicketSizeMonthData, UnlockTicketSizeMonthData, downlaodMsiDataList } from './ActionCreator';
import moment from 'moment';
import Loader from '../../../presentationals/Loader/Loader.component'
import MenuBar from './MenuBar'
import Popup from '../../../presentationals/Popup/Popup.component'
import DateFilterSelect from "../../../CustomDatePicker/DateFilterSelectold";
import { Download } from 'lucide-react'

const differenceDate = () => {
    let d = new Date()
    return d.getDate() - 1;
}

const InitalDate = (type) => {
    const FirstDay = moment().subtract(differenceDate(), 'days');
    if (type === 'fromDate') return FirstDay.format('YYYY-MM-DD');
    else if (type === 'toDate') return moment(new Date()).format('YYYY-MM-DD');
}

const getDateRange = (type) => {
    let fromDate;
    if (type === "3month") fromDate = moment().subtract(3, 'months').startOf('month');
    else if (type === "6month") fromDate = moment().subtract(6, 'months').startOf('month');
    else if (type === "1year") fromDate = moment().subtract(1, 'year').startOf('month');
    else return null;
    const toDate = moment().subtract(1, 'months').endOf('month');
    return { fromDate: fromDate.format('YYYY-MM-DD'), toDate: toDate.format('YYYY-MM-DD') };
};

const CACDashboard = ({ nbfcList, admin, handleActiveFilteration, currentActiveFilters }) => {
    const [view, setView] = useState("list")
    const [loader, setLoader] = useState(false)
    const [GraphBoxHeight, setGraphBoxHeight] = useState("")
    const [selectedDataIndex, setselectedDataIndex] = useState("-1")
    const [selectedDataHeading, setselectedDataHeading] = useState("")
    const [selectedData, setselectedData] = useState([])
    const [ActiveMonthFilter, setActiveMonthFilter] = useState(currentActiveFilters?.ActiveMonthFilter ?? "")
    const [editData, setEditData] = useState({ show: false, data: {} })
    const [editedValues, setEditedValues] = useState({})
    const [ListType, setListType] = useState("list")
    const [APIData, setAPIData] = useState()
    const [popup, setpopup] = useState({ show: false, popupStatus: "" })
    const [payload, setPayload] = useState({
        fromDate: currentActiveFilters?.fromDate ?? "",
        toDate: currentActiveFilters?.toDate ?? "",
        nbfcId: currentActiveFilters?.nbfcId ?? "",
        productId: currentActiveFilters?.productId ?? ""
    })

    useEffect(() => { getMonthWiseCollectionEfficiencyByDateFn(payload) }, [])

    useEffect(() => {
        handleActiveFilteration({
            fromDate: payload?.fromDate ?? "",
            toDate: payload?.toDate ?? "",
            nbfcId: payload?.nbfcId ?? "",
            productId: payload?.productId ?? "",
            ActiveMonthFilter: ActiveMonthFilter ?? ""
        })
    }, [payload, ActiveMonthFilter])

    const handleDate = (e, type) => {
        if (type === "applyFilter") {
            setActiveMonthFilter("")
            setselectedDataIndex("-1")
            setselectedDataHeading("")
            setselectedData([])
            getMonthWiseCollectionEfficiencyByDateFn(payload)
        } else {
            setPayload(prev => ({ ...prev, [type]: e.target.value }))
        }
    }

    const handleDateFilterPopup = (type, val) => {
        setPayload((prev) => ({ ...prev, [type]: val }));

        const formatted = moment(val).format("YYYY-MM-DD");

        setPayload((prev) => {
            if (prev[type] === formatted) return prev;

            return {
                ...prev,
                [type]: formatted
            };
        });


    };

    const handlemonthFilter = (type) => {
        setActiveMonthFilter(type)
        const { fromDate, toDate } = getDateRange(type);
        const obj = { fromDate, toDate, nbfcId: payload?.nbfcId || "", productId: payload?.productId || "" }
        setPayload(obj)
        setselectedDataIndex("-1")
        setselectedDataHeading("")
        setselectedData([])
        getMonthWiseCollectionEfficiencyByDateFn(obj)
    }

    const getMonthWiseCollectionEfficiencyByDateFn = (data) => {
        const sDate = moment(data?.fromDate).format("DD-MM-YYYY")
        const eDate = moment(data?.toDate).format("DD-MM-YYYY")
        setLoader(true)
        getMonthWiseTicketSizeByDateAPI(sDate, eDate, data?.nbfcId, data?.productId, callback => {
            setLoader(false)
            if (callback?.message === "success" && callback?.status === 200) {
                setAPIData(callback?.data)
                setTimeout(() => { HandlechartHeight() }, 200)
            } else {
                setAPIData([])
            }
        })
    }

    const handleSelectedRow = (fieldKey, index) => {
        if (ListType === "edit") {
            setselectedDataIndex("-1"); setselectedDataHeading(""); setselectedData([])
        } else {
            if (selectedDataIndex === index) {
                setselectedDataIndex("-1"); setselectedDataHeading(""); setselectedData([])
            } else {
                setselectedDataHeading(fieldKey)
                setselectedDataIndex(index)
                setselectedData(APIData?.map(item => ({ date: item?.monthName, value: item?.[fieldKey] })))
            }
        }
    }

    const HandlechartHeight = () => {
        let ele = document.getElementById("tableHeight")?.clientHeight;
        setGraphBoxHeight(ele)
    }

    const handleEdit = (value, data) => {
        setEditData({ show: value, data })
        if (value === true) {
            setListType("edit")
            setEditedValues(data)
            setselectedDataIndex("-1"); setselectedDataHeading(""); setselectedData([])
        } else {
            setListType("list")
            getMonthWiseCollectionEfficiencyByDateFn(payload)
        }
    }

    const handleSavingApi = (type, data) => {
        if (type === "lock") {
            const obj = {
                projectedLoanAmtDisbrused: data?.Projected_Loan_Amount_Disbursed,
                actualLoanAmtDisbrused: data?.Actual_Amount_Disbursed,
                actualLoanAmtDisbrusedNC: data?.Actual_Amount_Disbursed_NC,
                actualLoanAmtDisbrusedEC: data?.Actual_Amount_Disbursed_EC,
                averageProjectedLoanTicketSize: data?.Average_Projected_Loan_Ticket_Size,
                averageNewLoanTicketSizeDisbrused: data?.Average_New_Loan_Ticket_Size_Disbursed,
                averageExistingLoanTicketSizeDisbrushed: data?.Average_Existing_Loan_Ticket_Size_Disbursed,
                averageLoanTicketSizeDisbrused: data?.Average_Loan_Ticket_Size_Disbursed,
                month: data?.Month_Name, createdBy: admin.emailId, lock: true
            }
            SaveLockTicketSizeMonthData(obj, callback => {
                if (callback?.message === "success" && callback?.status === 200) {
                    setpopup({ show: true, popupStatus: 'Data Locked Successfully' })
                    getMonthWiseCollectionEfficiencyByDateFn(payload)
                } else {
                    setpopup({ show: true, popupStatus: 'error Locking' })
                }
                removePopup()
            })
        } else if (type === "save") {
            const obj = {
                projectedLoanAmtDisbrused: editedValues?.Projected_Loan_Amount_Disbursed,
                actualLoanAmtDisbrused: editedValues?.Actual_Amount_Disbursed,
                actualLoanAmtDisbrusedNC: editedValues?.Actual_Amount_Disbursed_NC,
                actualLoanAmtDisbrusedEC: editedValues?.Actual_Amount_Disbursed_EC,
                averageProjectedLoanTicketSize: editedValues?.Average_Projected_Loan_Ticket_Size,
                averageNewLoanTicketSizeDisbrused: editedValues?.Average_New_Loan_Ticket_Size_Disbursed,
                averageExistingLoanTicketSizeDisbrushed: editedValues?.Average_Existing_Loan_Ticket_Size_Disbursed,
                averageLoanTicketSizeDisbrused: editedValues?.Average_Loan_Ticket_Size_Disbursed,
                month: editedValues?.Month_Name, createdBy: admin.emailId, lock: false
            }
            SaveLockTicketSizeMonthData(obj, callback => {
                if (callback?.message === "success" && callback?.status === 200) {
                    getMonthWiseCollectionEfficiencyByDateFn(payload)
                    setpopup({ show: true, popupStatus: 'Data Saved Successfully' })
                    handleEdit(false, "")
                } else {
                    setpopup({ show: true, popupStatus: 'Error saving data' })
                }
                removePopup()
            })
        }
    }

    const closePopup = () => setpopup({ show: false, popupStatus: '' })
    const removePopup = () => setTimeout(() => closePopup(), 5000)

    const handleUnlock = (data) => {
        const obj = { month: data?.Month_Name ?? "", createdBy: admin?.emailId, lock: true }
        UnlockTicketSizeMonthData(obj, callback => {
            if (callback?.message === "success" && callback?.status === 200) {
                setpopup({ show: true, popupStatus: 'Data UnLocked Successfully' })
                getMonthWiseCollectionEfficiencyByDateFn(payload)
            } else {
                setpopup({ show: true, popupStatus: 'error UnLocked' })
            }
            removePopup()
        })
    }

    const handlwDownload = () => {
        setLoader(true)
        const sDate = moment(payload?.fromDate).format("DD-MM-YYYY");
        const eDate = moment(payload?.toDate).format("DD-MM-YYYY");
        downlaodMsiDataList(sDate, eDate, payload?.nbfcId, payload?.productId, "ticketSizeData", callback => {
            setLoader(false)

        })
    }

    const isDisabled = view === "edit"

    return (
        <div className="mis-dashboard">
            {loader && <Loader />}
            {popup?.show && <Popup popupStatus={popup?.popupStatus} closePopup={closePopup} />}

            {/* ── Page Header ── */}
            <div className="mis-page-header">
                <div className="mis-page-header-left">
                    <h1 className="mis-page-title">Ticket Size</h1>
                    <p className="mis-page-sub">Month-wise ticket size breakdown</p>
                </div>
                <div className="mis-page-header-right">
                    <span className="mis-live-badge">
                        <span className="mis-live-dot" />
                        Live
                    </span>
                </div>
            </div>

            {/* ── Filter Bar ── */}
            <div className="mis-filter-bar">
                <div className="mis-filter-group">
                    <label className="mis-filter-label">From date - To date</label>

                    <DateFilterSelect
                        value={[new Date(payload.fromDate), new Date(payload.toDate)]}
                        isFilterCleared={false}
                        onChange={(range) => {
                            handleDateFilterPopup("fromDate", range[0]);
                            handleDateFilterPopup("toDate", range[1]);
                        }}
                        customStyle={{ border: 'none', paddingLeft: '0' }}
                    />
                </div>

                {/* <div className="mis-filter-divider" />

                <div className="mis-filter-group">
                    <label className="mis-filter-label">To date</label>
                    <input
                        type="date"
                        className="mis-filter-input"
                        style={{ fontSize: window.innerWidth > 1800 ? "16px" : "13px" }}
                        value={payload?.toDate}
                        min={payload?.fromDate}
                        onChange={(e) => handleDate(e, 'toDate')}
                        disabled={isDisabled}
                    />
                </div> */}

                <div className="mis-filter-divider" />

                <div className="mis-filter-group">
                    <label className="mis-filter-label">NBFC</label>
                    <select
                        className="mis-filter-input"
                        style={{ fontSize: window.innerWidth > 1800 ? "16px" : "13px" }}
                        value={payload?.nbfcId}
                        onChange={(e) => handleDate(e, 'nbfcId')}
                        disabled={isDisabled}
                    >
                        <option value="">All NBFCs</option>
                        {nbfcList?.map((v) => (
                            <option key={v.nbfcId} value={v.nbfcId}>{v.name}</option>
                        ))}
                    </select>
                </div>

                <div className="mis-filter-divider" />

                <div className="mis-filter-group">
                    <label className="mis-filter-label">Product</label>
                    <select
                        className="mis-filter-input"
                        style={{ fontSize: window.innerWidth > 1800 ? "16px" : "13px" }}
                        value={payload?.productId}
                        onChange={(e) => handleDate(e, 'productId')}
                        disabled={isDisabled}
                    >
                        <option value="">All Products</option>
                        <option value="loan">Loan</option>
                    </select>
                </div>
                <div style={{ display: 'flex', gap: '5px', marginLeft: 'auto' }}>
                    <button
                        className="mis-apply-btn"
                        onClick={(e) => handleDate(e, 'applyFilter')}
                        disabled={isDisabled}
                    >
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <circle cx="6" cy="6" r="4.5" stroke="currentColor" strokeWidth="1.4" />
                            <path d="M9.5 9.5L12.5 12.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
                        </svg>
                    </button>
                    <button className="mis-download-btn" onClick={(e) => handlwDownload()}>
                        <Download style={{ color: "white", width: '14px', height: '14px' }} />
                    </button>

                </div>
            </div>

            {/* ── Month Quick Filters ── */}
            {/* <div className="mis-month-filter-bar">
                <span className="mis-month-filter-label">Quick range</span>
                {[
                    { key: '3month', label: 'Last 3 Months' },
                    { key: '6month', label: 'Last 6 Months' },
                    { key: '1year',  label: 'Last 1 Year'   },
                ].map(({ key, label }) => (
                    <button
                        key={key}
                        className={`mis-month-btn${ActiveMonthFilter === key ? ' active' : ''}`}
                        onClick={() => handlemonthFilter(key)}
                        disabled={isDisabled}
                    >
                        {label}
                    </button>
                ))}
            </div> */}

            {/* ── Table + Chart ── */}
            <div className="mis-table-section">
                <div className="mis-table-section-header">
                    <span className="mis-table-section-title">Month-wise breakdown</span>
                    <span className="mis-table-section-hint">Scroll horizontally to see all months →</span>
                </div>

                <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
                    {/* Table */}
                    <div
                        className="mis-table-outer"
                        id="tableHeight"
                        style={{
                            flex: selectedDataIndex !== '-1' ? '0 0 55%' : '1 1 100%',
                            transition: 'flex 0.3s ease',
                            boxShadow: selectedDataIndex !== '-1' ? '0 0 24px rgba(15,23,42,0.10)' : undefined,
                        }}
                    >
                        <div className="mis-table-scroll">
                            <table className="mis-table">
                                <thead>
                                    <tr>
                                        <th className="col-particulars">Particulars</th>
                                        {APIData?.length > 0 && APIData?.map((item, index) => (
                                            <th key={index} className="col-month">
                                                <MenuBar
                                                    totalData={item}
                                                    ButtonName={item?.Month_Name}
                                                    ListType={ListType}
                                                    EditData={editedValues}
                                                    onEdit={() => handleEdit(true, item)}
                                                    onView={() => handleEdit(false, "")}
                                                    onSave={() => handleSavingApi("save", item)}
                                                    onLock={() => handleSavingApi("lock", item)}
                                                    onUnLock={() => handleUnlock(item)}
                                                />
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {APIData?.length > 0 &&
                                        Object.keys(APIData[0])
                                            ?.filter(key => key !== 'Month_Name' && key !== 'isLocked' && key !== 'canEdit')
                                            ?.map((fieldKey, index) => (
                                                <tr
                                                    key={index}
                                                    className="mis-data-row"
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => handleSelectedRow(fieldKey, index)}
                                                    style={{ padding: window.innerWidth > 1800 ? "14px 16px" : "10px 16px" }}
                                                >
                                                    <td
                                                        className="mis-particulars-cell"
                                                        style={{
                                                            fontSize: window.innerWidth > 1800 ? "15.5px" : "12.5px",
                                                            background: selectedDataIndex === index ? '#EFF6FF' : undefined,
                                                        }}
                                                    >
                                                        <span
                                                            className="mis-row-bar"
                                                            style={{ background: selectedDataIndex === index ? '#2563EB' : '#94A3B8' }}
                                                        />
                                                        {fieldKey?.replace(/_/g, " ")}
                                                    </td>
                                                    {APIData?.map((item, colIndex) => {
                                                        const isEditing = editData.show && editData.data.Month_Name === item.Month_Name;
                                                        return (
                                                            <td
                                                                key={colIndex}
                                                                className="mis-value-cell"
                                                                style={{
                                                                    fontSize: window.innerWidth > 1800 ? "15.5px" : "12.5px",
                                                                    background: selectedDataIndex === index ? '#EFF6FF' : undefined,
                                                                    color: selectedDataIndex === index ? '#1E40AF' : undefined,
                                                                    fontWeight: selectedDataIndex === index ? '600' : undefined,
                                                                }}
                                                            >
                                                                {isEditing && (fieldKey === "Average_Projected_Loan_Ticket_Size" || fieldKey === "Projected_Loan_Amount_Disbursed") ? (
                                                                    <input
                                                                        className="mis-edit-input"
                                                                        type="number"
                                                                        value={editedValues[fieldKey] ?? item[fieldKey]}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                        onChange={(e) => setEditedValues(prev => ({ ...prev, [fieldKey]: e.target.value }))}
                                                                    />
                                                                ) : (
                                                                    Number(item[fieldKey])?.toLocaleString("en-IN")
                                                                )}
                                                            </td>
                                                        )
                                                    })}
                                                </tr>
                                            ))
                                    }
                                    {(!APIData || APIData.length === 0) && (
                                        <tr className="mis-nodata-row">
                                            <td colSpan={20}>No data available</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* Chart Panel */}
                    {selectedData?.length > 0 && (
                        <div
                            className="mis-chart-panel"
                            style={{ height: GraphBoxHeight || 400 }}
                        >
                            <div className="mis-chart-panel-header">
                                <span className="mis-chart-panel-title">
                                    {selectedDataHeading?.replace(/_/g, " ")}
                                </span>
                                <button
                                    className="mis-chart-close-btn"
                                    onClick={() => { setselectedDataIndex("-1"); setselectedData([]); setselectedDataHeading("") }}
                                >
                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                                        <path d="M2 2l10 10M12 2L2 12" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
                                    </svg>
                                </button>
                            </div>
                            <div style={{ height: (GraphBoxHeight || 400) - 52 }}>
                                <ResponsiveContainer width="100%" height="100%">
                                    <BarChart
                                        data={selectedData}
                                        barSize={ActiveMonthFilter === '3month' ? 36 : ActiveMonthFilter === '6month' ? 26 : 18}
                                        margin={{ top: 16, right: 16, left: 10, bottom: 8 }}
                                    >
                                        <defs>
                                            <linearGradient id="ticketBarGradient" x1="0" y1="0" x2="0" y2="1">
                                                <stop offset="0%" stopColor="#2563EB" stopOpacity={1} />
                                                <stop offset="100%" stopColor="#93C5FD" stopOpacity={0.6} />
                                            </linearGradient>
                                        </defs>
                                        <CartesianGrid stroke="#E4EAF4" vertical={false} />
                                        <XAxis dataKey="date" tick={{ fontSize: 11, fill: '#94A3B8' }} axisLine={false} tickLine={false} />
                                        <YAxis tick={{ fontSize: 11, fill: '#94A3B8' }} axisLine={false} tickLine={false} padding={{ top: 16 }} />
                                        <Tooltip
                                            contentStyle={{ background: '#fff', border: '1px solid #E4EAF4', borderRadius: '8px', fontSize: '12px', boxShadow: '0 4px 12px rgba(15,23,42,0.08)' }}
                                            cursor={{ fill: '#EFF6FF' }}
                                        />
                                        <Bar dataKey="value" fill="url(#ticketBarGradient)" radius={[6, 6, 0, 0]} />
                                    </BarChart>
                                </ResponsiveContainer>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default CACDashboard